import { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import { useSnackbar } from "../../../context/popup";
import { setCircleLoading } from "../../../components/Loading";


const ViewGeneralAddon = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const params = useParams();
  const [addonData, setAddonData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/general/addons/${paramId}`).then((res) => {
            setAddonData((prevData) => ({
              ...prevData,
              ...res?.data?.addon,
            }));
          });
        } catch (error) {
          console.error("Error fetching Data",error);
          showSnackbar(error?.response?.data?.message || "Network Error", "error");
        } finally {
            setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  const chunkArray = (arr = [], size = 2) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  return (
    <DashboardLayout>
        <Box
          sx={{
            padding: { xs: 2, md: 2 },
            bgcolor: "#f9f9f9",
            minHeight: "100vh",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="left"
            spacing={1}
            mb={2}
          >
            <IconButton
              onClick={() => navigate("/general-master/general-addon")}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
              General Addon Information
            </Typography>
          </Stack>

          {addonData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {addonData?.name}
                  </Typography>
                  <TextContainerField label="IPL Addon ID" value={addonData?.id} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Description" value={addonData?.description} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Products"
                    value={
                      addonData?.products?.length ? (
                        chunkArray(addonData.products).map((row, i) => (
                          <div key={i}>
                            {row.map((p) => p.keyName).join(", ")}
                          </div>
                        ))
                      ) : (
                        "-"
                      )
                    }
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField label="Policy Types"
                    value={
                      addonData?.policyTypes?.length ? (
                        chunkArray(addonData.policyTypes).map((row, i) => (
                          <div key={i}>
                            {row.map((p) => p.keyName).join(", ")}
                          </div>
                        ))
                      ) : (
                        "-"
                      )
                    }
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField label="Auto Apply" value={addonData?.autoApply ? "Yes" : "No"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Mandatory" value={addonData?.mandatory ? "Yes" : "No"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Status" value={addonData?.isActive ? "Active" : "Inactive"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Created At" value={addonData?.createdAt} labelStyle={{ fontWeight: "500" }} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          ) : (
            <Box>
              <Typography variant="h4" gutterBottom sx={{ textAlign: "center", fontWeight: "bold", color: "red", fontFamily: "cursive" }}>
                No Addon Data Found
              </Typography>
            </Box>
          )}
        </Box>
    </DashboardLayout>
  );
};

export default ViewGeneralAddon;
